/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openFinanceSlideout } from '../../actions/lister-actions';
import { FinanceInstallments } from './FinanceInstallments';

const FinanceWithChevron = ({
	NewDayFinanceQuote,
	productTitle,
	MemberPrice,
	NowPrice,
	Code: productSku,
	ColourId: productId,
	financeType,
	financePromotions,
	State,
	memberPricePod,
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false
	},
	isSwitch24Product,
	Switch24Pricing,
}) => {
	const dispatch = useDispatch();

	const { AnnualMembershipFee, DeliveryPricingInPricePod, UseUpfrontPricingAmounts, UseSwitch24 } = useSelector(
		(state) => state.featureSwitches
	);

	const slideoutPayload = {
		productId,
		productSku,
		nowPrice: NowPrice,
		memberPrice: MemberPrice,
		annualMembershipFee: AnnualMembershipFee,
		financePromotionCodes: financePromotions
			? financePromotions.map((p) => p.PromotionCode)
			: [],
		isInStock: State !== 'OutOfStock',
		memberUpfrontPaymentAmount: UpfrontPricing?.MemberUpfrontPaymentAmount,
		upfrontPaymentAmount: UpfrontPricing?.UpfrontPaymentAmount,
		upfrontPaymentPercentage: UpfrontPricing?.UpfrontPaymentPercentage,
		upfrontPaymentsEnabled: UseUpfrontPricingAmounts,
		Switch24Pricing: Switch24Pricing,
		isSwitch24Enabled: UseSwitch24
	};

	const switchMonthlyPayment = Switch24Pricing?.Switch24FinanceQuote?.MonthlyPayment

	return MemberPrice ? (
		memberPricePod ? (
			<div
				aria-label="Instalments Finance Promotion"
				className="cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative mt-1"
				tabIndex={0}
				role="link"
				onClick={() => {
					dispatch(
						openFinanceSlideout({
							...slideoutPayload,
						})
					);
				}}
				data-tag-name="member-price-monthly-installments-button"
				data-tag-finance-type="member-monthly-installments-button"
				data-tag-product={productTitle}
				data-testid="finance-instalments">
				<FinanceInstallments
					UpfrontPricing={UpfrontPricing}
					UseUpfrontPricingAmounts={UseUpfrontPricingAmounts}
					DeliveryPricingInPricePod={DeliveryPricingInPricePod}
					NewDayFinanceQuote={NewDayFinanceQuote}	
					isSwitch24Product={isSwitch24Product}
					switchMonthlyPayment={switchMonthlyPayment}
				/>
			</div>			
		) : (
			<div
				aria-label="Instalments Finance Promotion"
				className={`${
					DeliveryPricingInPricePod ? 'ml-0' : 'ml-3'
				} cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative ${isSwitch24Product ? 'mb-0' : 'mb-3'}`}
				tabIndex={0}
				role="link"
				onClick={() => {
					dispatch(
						openFinanceSlideout({
							...slideoutPayload,
						})
					);
				}}
				data-tag-name="non-member-display-monthly-installments-button"
				data-tag-finance-type={`${financeType}`}
				data-tag-product={productTitle}
				data-testid="non-member-lister-finance-instalments">
				<FinanceInstallments
					UpfrontPricing={UpfrontPricing}
					UseUpfrontPricingAmounts={UseUpfrontPricingAmounts}
					DeliveryPricingInPricePod={DeliveryPricingInPricePod}
					NewDayFinanceQuote={NewDayFinanceQuote}
					isSwitch24Product={isSwitch24Product}
					switchMonthlyPayment={switchMonthlyPayment}
				/>
			</div>
		)
	) : (
		<div
			aria-label="Instalments Finance Promotion"
			className={`${isSwitch24Product ? 'mb-0' : 'mb-3'} cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative`} 
			tabIndex="0"
			role="link"
			onClick={() => {
				dispatch(
					openFinanceSlideout({
						...slideoutPayload,
					})
				);
			}}
			data-tag-name="non-member-display-monthly-installments-button"
			data-tag-finance-type={`${financeType}`}
			data-tag-product={productTitle}
			data-testid="non-member-lister-finance-instalments">
			<FinanceInstallments
				UpfrontPricing={UpfrontPricing}
				UseUpfrontPricingAmounts={UseUpfrontPricingAmounts}
				DeliveryPricingInPricePod={DeliveryPricingInPricePod}
				NewDayFinanceQuote={NewDayFinanceQuote}
				isSwitch24Product={isSwitch24Product}
				switchMonthlyPayment={switchMonthlyPayment}
			/>
		</div>
	);
};

export default FinanceWithChevron;
